import { DocumentationIcon } from 'components/core/Navigation/NavigationDrawer/icons';
import { DocumentationFileNavigationAction } from 'components/documentation/actions/DocumentationFileNavigationAction';
import { formatTranslation } from 'intl';
import React from 'react';
import { useIntl } from 'react-intl';
import { useGalleryContext } from '..';
import { identitySelector } from '../selectors';
import { ActionButton } from './actionButton';
import { CommonTranslationKeys } from 'intl/keys';

interface GoToDocumentationFileButtonProps {
  isMobile: boolean;
}

export const GoToDocumentationFileButton: React.FC<
  GoToDocumentationFileButtonProps
> = ({ isMobile }) => {
  const intl = useIntl();
  const [file] = useGalleryContext().useMainDisplayedFile(identitySelector);

  const documentationId = file?.documentationId;

  return (
    <DocumentationFileNavigationAction documentationId={documentationId}>
      {({ canNavigate, navigateToDocumentationFile }) => {
        if (!canNavigate) {
          return null;
        }

        const label = formatTranslation(
          intl,
          CommonTranslationKeys.buttonTooltipOpenFileInDocumentation
        );

        return (
          <ActionButton
            isMobile={isMobile}
            onClick={navigateToDocumentationFile}
            disabled={false}
            tooltipTitle={label}
            label={label}
            icon={<DocumentationIcon fontSize='small' />}
          />
        );
      }}
    </DocumentationFileNavigationAction>
  );
};
